/**
 * LD.CLPBP.Public.Service
 * No descripton provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
import * as models from './models';

export interface LDCLPBPPublicApiModelsBorrowersRegisterForPersonalLoanRequest {
    

    personalLoansGuid?: string;

    epsUserGuid?: string;

    interactionGuid?: string;

    loanType?: LDCLPBPPublicApiModelsBorrowersRegisterForPersonalLoanRequest.LoanTypeEnum;

    loanPurpose?: LDCLPBPPublicApiModelsBorrowersRegisterForPersonalLoanRequest.LoanPurposeEnum;

    requestedLoanAmount?: number;

    projectType?: LDCLPBPPublicApiModelsBorrowersRegisterForPersonalLoanRequest.ProjectTypeEnum;

    emailAddress?: string;

    password?: string;

    firstName?: string;

    nameSuffix?: string;

    lastName?: string;

    address?: models.LDCLPBPPublicApiModelsCommonAddress;

    phoneNumber?: string;

    dateOfBirth?: Date;

    leadGuid?: string;

    occupancyStatus?: LDCLPBPPublicApiModelsBorrowersRegisterForPersonalLoanRequest.OccupancyStatusEnum;

    homeMonthlyPayment?: number;

    annualIncome?: number;

    creditScoreEstimate?: LDCLPBPPublicApiModelsBorrowersRegisterForPersonalLoanRequest.CreditScoreEstimateEnum;

    borrowerSource?: string;

    jornayaLeadID?: string;

    isPhoneContactConsentAccepted?: boolean;

    termsOfUseAccepted?: boolean;

    eSignConsentAccepted?: boolean;

    creditReportAuthorizationAccepted?: boolean;

    tcpaDisclosureAccepted?: boolean;

    loanDepotPrivacyPolicy?: boolean;

    deviceInfo?: models.LDCLPBPPublicApiModelsCommonDeviceInfo;
}
export namespace LDCLPBPPublicApiModelsBorrowersRegisterForPersonalLoanRequest {

    export enum LoanTypeEnum { 
        Undefined = <any> 'Undefined',
        Personal = <any> 'Personal',
        HomeImprovement = <any> 'HomeImprovement',
    }

    export enum LoanPurposeEnum { 
        CreditCardRefinancing = <any> 'CreditCardRefinancing',
        DebtConsolidation = <any> 'DebtConsolidation',
        HomeImprovement = <any> 'HomeImprovement',
        MajorPurchase = <any> 'MajorPurchase',
        HomePurchase = <any> 'HomePurchase',
        CarFinancing = <any> 'CarFinancing',
        GreenLoan = <any> 'GreenLoan',
        Business = <any> 'Business',
        Vacation = <any> 'Vacation',
        MovingAndRelocation = <any> 'MovingAndRelocation',
        MedicalExpenses = <any> 'MedicalExpenses',
        Other = <any> 'Other',
    }

    export enum ProjectTypeEnum { 
        ConcreteBrickAndStone = <any> 'ConcreteBrickAndStone',
        DeckingShadeStructures = <any> 'DeckingShadeStructures',
        Electrical = <any> 'Electrical',
        FlooringAndHardwood = <any> 'FlooringAndHardwood',
        GeneralContractor = <any> 'GeneralContractor',
        Generators = <any> 'Generators',
        HeatingAndAC = <any> 'HeatingAndAC',
        HurricaneStructures = <any> 'HurricaneStructures',
        Insulation = <any> 'Insulation',
        Landscaping = <any> 'Landscaping',
        Lighting = <any> 'Lighting',
        PaintingAndStaining = <any> 'PaintingAndStaining',
        PlumbingAndHeating = <any> 'PlumbingAndHeating',
        Remodeling = <any> 'Remodeling',
        Roofing = <any> 'Roofing',
        Seawalls = <any> 'Seawalls',
        Seismic = <any> 'Seismic',
        Solar = <any> 'Solar',
        SwimmingPoolsAndSpas = <any> 'SwimmingPoolsAndSpas',
        WaterSaving = <any> 'WaterSaving',
        WindowsAndDoors = <any> 'WindowsAndDoors',
    }

    export enum OccupancyStatusEnum { 
        FullyOwn = <any> 'FullyOwn',
        Mortgage = <any> 'Mortgage',
        Other = <any> 'Other',
        Own = <any> 'Own',
        Rent = <any> 'Rent',
        NoRentOrHousingPayment = <any> 'NoRentOrHousingPayment',
    }

    export enum CreditScoreEstimateEnum { 
        Excellent = <any> 'Excellent',
        Good = <any> 'Good',
        Fair = <any> 'Fair',
        Poor = <any> 'Poor',
    }
}
